import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionService } from '../../../services/subscription';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const useSetDefaultPaymentMethod = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (paymentMethodId: string) =>
      subscriptionService.setDefaultPaymentMethod(paymentMethodId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['paymentMethods'] });
      toast.success(tActionMessages.defaultPaymentMethodUpdatedSuccessfully);
    },
    onError: (error: any) => {
      toast.error(error?.response?.errors?.[0]?.message || tActionMessages.failedToUpdateDefaultPaymentMethod);
    },
  });
};
